<template>
    <div class="content-center" style="display: flex; flex-direction: column;">
        <div class="container-sm">
            <div class="title-center mb40">
                <div class="uppercase">
                    {{ $t('auth.login') }}
                </div>
                <div class="subtitle-center">
                    {{ $t('auth.infoMessageToPassenger') }}
                </div>
            </div>

            <div v-on:keyup.enter="onEnterSubmit">
                <intl-tel
                    :label="$t('transfer.phoneNumber')"
                    v-on:change="showEfects"
                />
            </div>

            <div>
                <md-button
                    class="mt16 uppercase"
                    :class="{
                        'btn-default-blue': isValidPhoneNumber,
                        'btn-default-action': !isValidPhoneNumber
                    }"
                    style="margin-left:0;"
                    @click="submit"
                    @keyup.enter.native="submitResetPassword"
                    >{{ $t('auth.signIn') }}</md-button
                >
            </div>
        </div>
        <div v-if="!appIsInstalled" class="mt16 mb16 install-app flex">
            <div class="container-sm">
                <p class="center">
                    {{ $t('app.passenger') }}
                </p>

                <md-button
                    class="default-button install-button"
                    style="margin-left:0;"
                    @click="install"
                    >{{ $t('auth.install') }}</md-button
                >
                <div class="column">
                    <md-button
                        class="c191456"
                        href="https://bus-do-polski.pl/przejazdy/aplikacja-bus-do-polski/"
                        target="_blank"
                        >{{ $t('auth.instruction') }}</md-button
                    >
                </div>
                <div style="margin-bottom:0px;">
                    {{ $t('auth.alsoAvailableOn') }}
                </div>
                <div class="one-row">
                    <div
                        @click="$toast.success($t('auth.isComingMessage'))"
                        class="pointer"
                    >
                        <img
                            alt="pobierz z AppStore"
                            src="@assets/images/app-store-badge.png"
                        />
                    </div>
                    <a
                        href="https://play.google.com/store/apps/details?id=com.flotea.bus_do_polski"
                        target="_blank"
                        ><img
                            alt="pobierz z Google Play"
                            src="@assets/images/google-play-badge.png"
                    /></a>
                </div>
            </div>
        </div>

        <div class="loading-overlay" v-if="loading">
            <div class="wrapper">
                <md-progress-spinner md-mode="indeterminate" :md-stroke="2" />
            </div>
        </div>
        <pwa-install
            v-if="!appIsInstalled"
            ref="installComponent"
            descriptionheader=""
            :installbuttontext="$t('auth.installbuttontext')"
            :cancelbuttontext="$t('auth.cancelbuttontext')"
            :iosinstallinfotext="$t('auth.iosinstallinfotext')"
            :explainer="$t('auth.passengerExplainer')"
            featuresheader=""
            manifestpath="/manifest.json"
        />
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import '@pwabuilder/pwainstall';
import '@matthew2097/intl-tel-material';

export default {
    data() {
        return {
            loading: false,
            isValidPhoneNumber: false,
            route_uid: '',
            phone: ''
        };
    },

    computed: {
        appIsInstalled() {
            if (window.matchMedia('(display-mode: standalone)').matches) {
                return true;
            } else {
                return false;
            }
        }
    },

    methods: {
        ...mapActions({
            verifyPhoneNumber: 'auth/loginByPhoneNumberAsPassenger',
            loginByRequestAsPassenger: 'auth/loginByRequestAsPassenger'
        }),

        showEfects(e) {
            const { isValid, value } = e.detail;
            this.isValidPhoneNumber = isValid;
            this.phone = value;
        },

        install() {
            const iphone5 = window.screen.width <= 320;

            if (!iphone5) {
                this.$refs.installComponent.manifestdata.description =
                    'Instalacja aplikacji z poziomu przeglądarki wygląda różnie, w zależności od urządzenia i oprogramowania. Na powyższych gifach zobaczysz jak wygląda instalacja na iOS lub na Android. Jeżeli masz problem z instalacją aplikacji w ten sposób, spróbuj na innej przeglądarce lub po prostu zainstaluj aplikację dla przewoźnika ze sklepu.';
            } else {
                this.$refs.installComponent.manifestdata.description = '';
            }

            this.$refs.installComponent.manifestdata.screenshots = this.screenshots;
            this.$refs.installComponent.openmodal = true;
        },

        onEnterSubmit() {
            if (this.isValidPhoneNumber) {
                this.login();
            } else {
                this.$toast.error(this.$t('global.somethingWrong'));
            }
        },

        submit() {
            if (this.isValidPhoneNumber) {
                this.login();
            }
        },

        async login() {
            this.loading = true;

            const redirectRoute =
                this.$route.query.redirectFrom &&
                this.$route.query.redirectFrom !== '/logout'
                    ? '/passenger' + this.$route.query.redirectFrom
                    : '/passenger/';

            if (this.route_uid) {
                const params = { route_uid: this.route_uid, phone: this.phone };
                const response = await this.loginByRequestAsPassenger(params);

                if (response) {
                    window.location.href = redirectRoute;
                    this.$toast.success(`${this.$t('global.welcomeBack')}!`);
                } else {
                    this.$toast.error(
                        this.$t('global.incorrectLoginCredentials')
                    );
                }
            } else {
                const response = await this.verifyPhoneNumber(this.phone);
                let path;

                if (this.$route.query.redirectFrom !== undefined) {
                    path = `/login/check-pin?redirectFrom=${this.$route.query.redirectFrom}`;
                } else {
                    path = '/login/check-pin?redirectFrom=/';
                }


                if(response.isVerified){
                    const responseLoginByToken = await this.loginByRequestAsPassenger({
                        route_uid: response.requestUUID,
                        phone: this.phone
                    });

                    if (responseLoginByToken) {
                        this.$router.push(`/app/${response.requestUUID}`);
                    } else {
                        this.$router.push(`/login?redirectFrom=/app/${response.requestUUID}`);
                    }

                    return;
                }

                this.$toast.success(this.$t('auth.smsWithCodeHasBeenSent'));
                this.$router.push(path);
            }

            setTimeout(() => {
                this.loading = false;
            }, 1000);
        }
    },

    mounted() {
        const { redirectFrom } = this.$route.query;

        const regex = /[0-9a-zA-Z]{8}\-[0-9a-zA-Z]{4}\-[0-9a-zA-Z]{4}\-[0-9a-zA-Z]{4}\-[0-9a-zA-Z]{12}/i;
        const found = redirectFrom ? redirectFrom.match(regex) : null;

        if (redirectFrom && !!found) {
            this.route_uid = found.shift();
        }
    }
};
</script>

<style scoped>
.subtitle-center {
    font-size: 18px;
}

.center {
    text-align: center;
}

.subtitle-center {
    font-size: 14px;
}
</style>
